import { BaseRouteService } from 'core/services';

class NikoPatientDetailInsuranceRouteService extends BaseRouteService {
    constructor() {
        super('niko-patient-detail-insurances');
    }

    get(id, options) {
        return super.get(this.base + '/{id}/{?embed,fields}', id, options);
    }

    create(resource) {
        return super.create(this.base, resource);
    }

    update(resource) {
        return super.update(this.base + '/{id}', resource);
    }

    delete(resource) {
        return super.delete(this.base + '/{id}', resource);
    }

    inactivate(resource) {
        return super.update(this.base + '/{id}/inactivate', resource);
    }

    swap(oldId) {
        return super.create(this.base + '/{id}/swap', { id: oldId });
    }
}

export default NikoPatientDetailInsuranceRouteService;